
/**
 * @constant
 * @description minimizeSidebar - Función propia de la plantilla
 */

const misc: any = {
  sidebar_mini_active: true,
};

// Minimiza menú de navegación lateral
export const minimizeSidebar = () => {

  const body = document.getElementsByTagName("body")[0];
  if (body.classList.contains("sidebar-mini")) {
    misc.sidebar_mini_active = true;
  } else {
    misc.sidebar_mini_active = false;
  }
  if (misc.sidebar_mini_active !== true) {
    body.classList.add("sidebar-mini");
    misc.sidebar_mini_active = true;
  } 
  // ? Se simula la ventana y se redimensiona para que los graficos se actialicen a tiempo real.
  const simulateWindowResize = setInterval(() => {
    window.dispatchEvent(new Event("resize"));
  }, 180);
  // ? Paramos la simulacion de la ventana y la redimensionamos despues de que la animación se haya completado.
  setTimeout(() => {
    clearInterval(simulateWindowResize);
  }, 1000);
}

// Maximiza menú de navegación lateral
export const maximizeSidebar = () => {
  const body = document.getElementsByTagName("body")[0];
  if (misc.sidebar_mini_active === true){
     body.classList.remove("sidebar-mini");
     misc.sidebar_mini_active = false;
  }
}
